import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/legacy.scoped.css";
import "./styles/refresh.scoped.css";
import { applyCachedUi } from "./theme/ui";
import App from "./App";
import { applyThemePreference } from "./theme/appearance";

// Pick the UI generation (legacy / refresh) and the stored light/dark
// preference before React mounts so there is no flash of the wrong look.
applyCachedUi();
applyThemePreference();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
